/** 投注项类型 see enum: selection_type */
export enum EFbSelectionType {
  /** {H}|主 */
  home = 1,
  /** {A}|客 */
  away = 2,
  /** 和 */
  draw = 3,
  /** 大 */
  over = 4,
  /** 小 */
  under = 5,
  /** 双 */
  even = 6,
  /** 单 */
  odd = 7,
  /** 是 */
  yes = 8,
  /** 否 */
  no = 9,
  /** W1 */
  w1 = 10,
  /** W2 */
  w2 = 11,
  /** 精确 */
  exact = 15,
  /** 无 */
  none = 16,
  /** {H}&大 {L}|主&大 {L} */
  homeOverL = 17,
  /** {H}&小 {L}|主&小 {L} */
  homeUnderL = 18,
  /** {A}&大 {L}|客&大 {L} */
  awayOverL = 19,
  /** {A}&小 {L}|客&小 {L} */
  awayUnderL = 20,
  /** 和局&大 {L} */
  drawOverL = 21,
  /** 和局&小 {L} */
  drawUnderL = 22,
  /** {H}&是|主&是 */
  homeYes = 23,
  /** {H}&否|主&否 */
  homeNo = 24,
  /** {A}&是|客&是 */
  awayYes = 25,
  /** {A}&否|客&否 */
  awayNo = 26,
  /** 和局&是 */
  drawYes = 27,
  /** 和局&否 */
  drawNo = 28,
  /** {H}/和局&大 {L}|主/和局&大 {L} */
  homeDrawOverL = 29,
  /** {H}/和局&小 {L}|主/和局&小 {L} */
  homeDrawUnderL = 30,
  /** {H}/{A}&大 {L}|主/客&大 {L} */
  homeAwayOverL = 31,
  /** {H}/{A}&小 {L}|主/客&小 {L} */
  homeAwayUnderL = 32,
  /** {A}/和局&大{L}|客/和局&大{L} */
  awayDrawOverL = 33,
  /** {A}/和局&小 {L}|客/和局&小 {L} */
  awayDrawUnderL = 34,
  /** {H}/和局|主/和局 */
  homeDraw_35 = 35,
  /** {H}/{A}|主/客 */
  homeAway_36 = 36,
  /** {A}/和局|客/和局 */
  awayDraw_37 = 37,
  /** 和局/{H}|和局/主 */
  drawHome = 38,
  /** 和局/{A}|和局/客 */
  drawAway = 39,
  /** {A}/{A}|客/客 */
  awayAway = 40,
  /** {H}/{H}|主/主 */
  homeHome = 41,
  /** {A}/{H}|客/主 */
  awayHome = 42,
  /** 和局/和局 */
  drawDraw = 43,
  /** {A}/和局&否|客/和局&否 */
  awayDrawNo = 44,
  /** {H}/{A}&否|主/客&否 */
  homeAwayNo = 45,
  /** {A}/和局&是|客/和局&是 */
  awayDrawYes = 46,
  /** {H}/{A}&是|主/客&是 */
  homeAwayYes = 47,
  /** {H}/和局&是|主/和局&是 */
  homeDrawYes = 48,
  /** {H}/和局&否|主/和局&否 */
  homeDrawNo = 49,
  /** {H}/和局|主/和局 */
  homeDraw_50 = 50,
  /** {H}/{A}|主/客 */
  homeAway_51 = 51,
  /** {A}/和局|客/和局 */
  awayDraw_52 = 52,
  /** 上半场 {L} */
  n1stHalfL = 53,
  /** 下半场 {L} */
  n2ndHalfL = 54,
  /** 平局 */
  equal = 55,
  /** 否/否 */
  noNo = 56,
  /** 是/否 */
  yesNo = 57,
  /** 是/是 */
  yesYes = 58,
  /** 否/是 */
  noYes = 59,
  /** {H} - 净胜1球 | 主-净胜1球 */
  homeWinBy1Goal = 63,
  /** {H} - 净胜2球 | 主-净胜2球 */
  homeWinBy2Goals = 64,
  /** {H} - 净胜3球或更多 | 主-净胜3球或更多 */
  homeWinBy3Goals = 65,
  /** {A} - 净胜1球 | 客-净胜1球 */
  awayWinBy1Goal = 66,
  /** {A} - 净胜2球 | 客-净胜2球 */
  awayWinBy2Goals = 67,
  /** {A} - 净胜3球或更多 | 客-净胜3球或更多 */
  awayWinBy3Goals = 68,
  /** 无进球 */
  drawNoGoals = 69,
  /** 进球和局 */
  drawWithGoals = 70,
  /** {H} - 常规时间 | 主 - 常规时间 */
  homeRegularTime = 71,
  /** {A} - 常规时间 | 客 - 常规时间 */
  awayRegularTime = 72,
  /** {H} - 加时赛 | 主 - 加时赛 */
  homeOT = 73,
  /** {A} - 加时赛 | 客 - 加时赛 */
  awayOT = 74,
  /** {H} - 点球大战 | 主 - 点球大战 */
  homePenalties = 75,
  /** {A} - 点球大战 | 客 - 点球大战 */
  awayPenalties = 76,
  /** 大 {L} & 是 */
  overLYes = 77,
  /** 小 {L} & 是 */
  underLYes = 78,
  /** 大 {L} & 否 */
  overLNo = 79,
  /** 小 {L} & 否 */
  underLNo = 80,
  /** {H} & {H}第{L}个进球 | 主 & 主队第{L}个进球 */
  homeHomeLthGoal = 81,
  /** 和局 & {H} 第{L}个进球 | 和局 & 主队第{L}个进球 */
  drawHomeLthScore = 82,
  /** {A} & {H} 第{L}个进球 | 客 & 主队第{L}个进球 */
  awayHomeLthScore = 83,
  /** {H} & {A} 第{L}个进球 | 主 & 客队第{L}个进球 */
  homeAwayLthScore = 84,
  /** 和局 & {A} 第{L}个进球 | 和局 & 客队第{L}个进球 */
  drawAwayLthScore = 85,
  /** {A} & {A} 第{L}个进球 | 客 & 客队第{L}个进球 */
  awayAwayLthScore = 86,
  /** 无进球 */
  noGoal = 87,
  /** 上半场开场 - 14:59分钟 */
  startOf1stHalf1459Mins = 88,
  /** 15:00 分钟– 29:59 分钟 */
  n15002959Mins = 89,
  /** 30:00分钟 - 半场 */
  n3000MinsHalfTime = 90,
  /** 下半场开场 - 59:59 分钟 */
  startOf2ndHalf5959Mins = 91,
  /** 60:00 分钟 – 74:59分钟 */
  n60007459Mins = 92,
  /** 75:00分钟 - 全场完场 */
  n7500MinsFullTime = 93,
  /** 射门 */
  shot = 94,
  /** 头球 */
  header = 95,
  /** 乌龙球 */
  ownGoal = 96,
  /** 点球 */
  penalty = 97,
  /** 任意球 */
  freeKick = 98,
  /** 0-0 */
  score_0_0_100 = 100,
  /** 0-1 */
  score_0_1_101 = 101,
  /** 0-2 */
  score_0_2_102 = 102,
  /** 0-3 */
  score_0_3_103 = 103,
  /** 0-4 */
  score_0_4_104 = 104,
  /** 0-5 */
  score_0_5_105 = 105,
  /** 0-6 */
  score_0_6_106 = 106,
  /** 0-7 */
  score_0_7_107 = 107,
  /** 0-8 */
  score_0_8_108 = 108,
  /** 0-9 */
  score_0_9_109 = 109,
  /** 1-0 */
  score_1_0_110 = 110,
  /** 1-1 */
  score_1_1_111 = 111,
  /** 1-2 */
  score_1_2_112 = 112,
  /** 1-3 */
  score_1_3_113 = 113,
  /** 1-4 */
  score_1_4_114 = 114,
  /** 1-5 */
  score_1_5_115 = 115,
  /** 1-6 */
  score_1_6_116 = 116,
  /** 1-7 */
  score_1_7_117 = 117,
  /** 1-8 */
  score_1_8_118 = 118,
  /** 1-9 */
  score_1_9_119 = 119,
  /** 2-0 */
  score_2_0_120 = 120,
  /** 2-1 */
  score_2_1_121 = 121,
  /** 2-2 */
  score_2_2_122 = 122,
  /** 2-3 */
  score_2_3_123 = 123,
  /** 2-4 */
  score_2_4_124 = 124,
  /** 2-5 */
  score_2_5_125 = 125,
  /** 2-6 */
  score_2_6_126 = 126,
  /** 2-7 */
  score_2_7_127 = 127,
  /** 2-8 */
  score_2_8_128 = 128,
  /** 2-9 */
  score_2_9_129 = 129,
  /** 3-0 */
  score_3_0_130 = 130,
  /** 3-1 */
  score_3_1_131 = 131,
  /** 3-2 */
  score_3_2_132 = 132,
  /** 3-3 */
  score_3_3_133 = 133,
  /** 3-4 */
  score_3_4_134 = 134,
  /** 3-5 */
  score_3_5_135 = 135,
  /** 3-6 */
  score_3_6_136 = 136,
  /** 3-7 */
  score_3_7_137 = 137,
  /** 3-8 */
  score_3_8_138 = 138,
  /** 3-9 */
  score_3_9_139 = 139,
  /** 4-0 */
  score_4_0_140 = 140,
  /** 4-1 */
  score_4_1_141 = 141,
  /** 4-2 */
  score_4_2_142 = 142,
  /** 4-3 */
  score_4_3_143 = 143,
  /** 4-4 */
  score_4_4_144 = 144,
  /** 4-5 */
  score_4_5_145 = 145,
  /** 4-6 */
  score_4_6_146 = 146,
  /** 4-7 */
  score_4_7_147 = 147,
  /** 4-8 */
  score_4_8_148 = 148,
  /** 4-9 */
  score_4_9_149 = 149,
  /** 5-0 */
  score_5_0_150 = 150,
  /** 5-1 */
  score_5_1_151 = 151,
  /** 5-2 */
  score_5_2_152 = 152,
  /** 5-3 */
  score_5_3_153 = 153,
  /** 5-4 */
  score_5_4_154 = 154,
  /** 5-5 */
  score_5_5_155 = 155,
  /** 5-6 */
  score_5_6_156 = 156,
  /** 5-7 */
  score_5_7_157 = 157,
  /** 5-8 */
  score_5_8_158 = 158,
  /** 5-9 */
  score_5_9_159 = 159,
  /** 6-0 */
  score_6_0_160 = 160,
  /** 6-1 */
  score_6_1_161 = 161,
  /** 6-2 */
  score_6_2_162 = 162,
  /** 6-3 */
  score_6_3_163 = 163,
  /** 6-4 */
  score_6_4_164 = 164,
  /** 6-5 */
  score_6_5_165 = 165,
  /** 6-6 */
  score_6_6_166 = 166,
  /** 6-7 */
  score_6_7_167 = 167,
  /** 6-8 */
  score_6_8_168 = 168,
  /** 6-9 */
  score_6_9_169 = 169,
  /** 7-0 */
  score_7_0_170 = 170,
  /** 7-1 */
  score_7_1_171 = 171,
  /** 7-2 */
  score_7_2_172 = 172,
  /** 7-3 */
  score_7_3_173 = 173,
  /** 7-4 */
  score_7_4_174 = 174,
  /** 7-5 */
  score_7_5_175 = 175,
  /** 7-6 */
  score_7_6_176 = 176,
  /** 7-7 */
  score_7_7_177 = 177,
  /** 7-8 */
  score_7_8_178 = 178,
  /** 7-9 */
  score_7_9_179 = 179,
  /** 8-0 */
  score_8_0_180 = 180,
  /** 8-1 */
  score_8_1_181 = 181,
  /** 8-2 */
  score_8_2_182 = 182,
  /** 8-3 */
  score_8_3_183 = 183,
  /** 8-4 */
  score_8_4_184 = 184,
  /** 8-5 */
  score_8_5_185 = 185,
  /** 8-6 */
  score_8_6_186 = 186,
  /** 8-7 */
  score_8_7_187 = 187,
  /** 8-8 */
  score_8_8_188 = 188,
  /** 8-9 */
  score_8_9_189 = 189,
  /** 9-0 */
  score_9_0_190 = 190,
  /** 9-1 */
  score_9_1_191 = 191,
  /** 9-2 */
  score_9_2_192 = 192,
  /** 9-3 */
  score_9_3_193 = 193,
  /** 9-4 */
  score_9_4_194 = 194,
  /** 9-5 */
  score_9_5_195 = 195,
  /** 9-6 */
  score_9_6_196 = 196,
  /** 9-7 */
  score_9_7_197 = 197,
  /** 9-8 */
  score_9_8_198 = 198,
  /** 9-9 */
  score_9_9_199 = 199,
  /** 10-0 */
  score_10_0 = 200,
  /** 10-1 */
  score_10_1 = 201,
  /** 10-2 */
  score_10_2 = 202,
  /** 10-3 */
  score_10_3 = 203,
  /** 10-4 */
  score_10_4 = 204,
  /** 10-5 */
  score_10_5 = 205,
  /** 10-6 */
  score_10_6 = 206,
  /** 10-7 */
  score_10_7 = 207,
  /** 10-8 */
  score_10_8 = 208,
  /** 10-9 */
  score_10_9 = 209,
  /** 0-10 */
  score_0_10 = 210,
  /** 1-10 */
  score_1_10 = 211,
  /** 2-10 */
  score_2_10 = 212,
  /** 3-10 */
  score_3_10 = 213,
  /** 4-10 */
  score_4_10 = 214,
  /** 5-10 */
  score_5_10 = 215,
  /** 6-10 */
  score_6_10 = 216,
  /** 7-10 */
  score_7_10 = 217,
  /** 8-10 */
  score_8_10 = 218,
  /** 9-10 */
  score_9_10 = 219,
  /** 11-0 */
  score_11_0 = 220,
  /** 11-1 */
  score_11_1 = 221,
  /** 11-2 */
  score_11_2 = 242,
  /** 11-3 */
  score_11_3 = 223,
  /** 11-4 */
  score_11_4 = 224,
  /** 11-5 */
  score_11_5 = 225,
  /** 11-6 */
  score_11_6 = 226,
  /** 11-7 */
  score_11_7 = 227,
  /** 11-8 */
  score_11_8 = 228,
  /** 11-9 */
  score_11_9 = 229,
  /** 11-10 */
  score_11_10 = 230,
  /** 0-11 */
  score_0_11 = 231,
  /** 1-11 */
  score_1_11 = 232,
  /** 2-11 */
  score_2_11 = 233,
  /** 3-11 */
  score_3_11 = 234,
  /** 4-11 */
  score_4_11 = 235,
  /** 5-11 */
  score_5_11 = 236,
  /** 6-11 */
  score_6_11 = 237,
  /** 7-11 */
  score_7_11 = 238,
  /** 8-11 */
  score_8_11 = 239,
  /** 9-11 */
  score_9_11_240 = 240,
  /** 10-11 */
  score_10_11 = 241,
  /** 0-12 */
  score_0_12 = 243,
  /** 12-0 */
  score_12_0 = 249,
  /** 其他 */
  others_222 = 222,
  /** 其他 */
  others_244 = 244,
  /** Others */
  others_250 = 250,
  /** 其他 */
  others_277 = 277,
  /** 其他 */
  others_290 = 290,
  /** 其他 */
  others_299 = 299,
  /** 0-0 */
  score_0_0_300 = 300,
  /** 0-1 */
  score_0_1_301 = 301,
  /** 2-3 */
  score_2_3_302 = 302,
  /** 4-6 */
  score_4_6_303 = 303,
  /** 6+ */
  n6_304 = 304,
  /** 7+ */
  n7_305 = 305,
  /** 3+ */
  n3_306 = 306,
  /** 0 */
  n0_311 = 311,
  /** 1 */
  n1_312 = 312,
  /** 2 */
  n2_313 = 313,
  /** 3 */
  n3_314 = 314,
  /** 4 */
  n4_315 = 315,
  /** 5 */
  n5_316 = 316,
  /** 6 */
  n6_317 = 317,
  /** 7 */
  n7_318 = 318,
  /** 8 */
  n8_319 = 319,
  /** 2+ */
  n2_320 = 320,
  /** 3+ */
  n3_321 = 321,
  /** 4+ */
  n4_327 = 327,
  /** 6+ */
  n6_322 = 322,
  /** 9+ */
  n9_323 = 323,
  /** 0-2 */
  score_0_2_330 = 330,
  /** 0-4 */
  score_0_4_331 = 331,
  /** 0-8 */
  score_0_8_332 = 332,
  /** 3-4 */
  score_3_4_333 = 333,
  /** 5-6 */
  score_5_6_334 = 334,
  /** 9-11 */
  score_9_11_335 = 335,
  /** 7+ */
  n7_336 = 336,
  /** 12+ */
  n12_337 = 337,
  /** 0-150 */
  score_0_150 = 338,
  /** 151-160 */
  score_151_160 = 339,
  /** 161-170 */
  score_161_170 = 340,
  /** 171-180 */
  score_171_180 = 341,
  /** 181-190 */
  score_181_190 = 342,
  /** 191-200 */
  score_191_200 = 343,
  /** 201-210 */
  score_201_210 = 344,
  /** 211-220 */
  score_211_220 = 345,
  /** 221-230 */
  score_221_230 = 346,
  /** 231-240 */
  score_231_240 = 347,
  /** 241-250 */
  score_241_250 = 348,
  /** 250.5+ */
  n2505 = 349,
  /** {H} - 净胜1-5分 | 主队净胜1-5分 */
  homeWinBy15Points = 350,
  /** {H} - 净胜6-10分 | 主队净胜6-10分 */
  homeWinBy610Points = 351,
  /** {H} - 净胜11-15分 | 主队净胜11-15分 */
  homeWinBy1115Points = 352,
  /** {H} - 净胜16-20分 | 主队净胜16-20分 */
  homeWinBy1620Points = 353,
  /** {H} - 净胜21-25分 | 主队净胜21-25分 */
  homeWinBy2125Points = 354,
  /** {H} - 净胜26分或更多 | 主队净胜26分或更多 */
  homeWinBy26Points = 355,
  /** {A} - 净胜1-5分 | 客队净胜1-5分 */
  awayWinBy15Points = 356,
  /** {A} - 净胜6-10分 | 客队净胜6-10分 */
  awayWinBy610Points = 357,
  /** {A} - 净胜11-15分 | 客队净胜11-15分 */
  awayWinBy1115Points = 358,
  /** {A} - 净胜16-20分 | 客队净胜16-20分 */
  awayWinBy1620Points = 359,
  /** {A} - 净胜21-25分 | 客队净胜21-25分 */
  awayWinBy2125Points = 360,
  /** {A} - 净胜26分或更多 | 客队净胜26分或更多 */
  awayWinBy26Points = 361,
  /** {H} - 净胜3分或更多 | 主队净胜3分或更多 */
  homeWinBy3Points = 362,
  /** {A} - 净胜3分或更多 | 客队净胜3分或更多 */
  awayWinBy3Points = 363,
  /** 其他 */
  other = 364,
  /** 第一节 */
  n1stQuarter = 365,
  /** 第二节 */
  n2ndQuarter = 366,
  /** 第三节 */
  n3rdQuarter = 367,
  /** 第四节 */
  n4thQuarter = 368,
  /** 只有{H} | 只有主队 */
  onlyHome = 369,
  /** 只有{A} | 只有客队 */
  onlyAway = 370,
  /** 两支球队 */
  bothTeams = 371,
  /** 其他 */
  others_255 = 255,
  /** 10+ */
  n10_324 = 324,
  /** 0-4 */
  score_0_4_325 = 325,
  /** 9 */
  n9_326 = 326,
  /** {H} 罚球 | 主队罚球 */
  home1Point = 372,
  /** {H} - 两分球 | 主队两分球 */
  home2Point = 373,
  /** {H} - 三分球 | 主队三分球 */
  home3Point = 374,
  /** {A} - 罚球 | 客队罚球 */
  away1Point = 375,
  /** {A} - 两分球 | 客队两分球 */
  away2Point = 376,
  /** {A} - 三分球 | 客队三分球 */
  away3Point = 377,
  /** 罚球 */
  n1Point = 378,
  /** 两分球 */
  n2Point = 379,
  /** 三分球 */
  n3Point = 380,
  /** 第一节 */
  n1stPeriod = 381,
  /** 第二节 */
  n2ndPeriod = 382,
  /** 第三节 */
  n3rdPeriod = 383,
  /** 第三回合 */
  n3rdRound = 384,
  /** 第四回合 */
  n4thRound = 385,
  /** 第五回合 */
  n5thRound = 386,
  /** 第六回合或更后 */
  n6thRoundOrLater = 387,
  /** {P1}-{P2} */
  p1P2 = 388,
  /** 主队通过击倒获胜 */
  hOMEBYKO = 400,
  /** 主队通过判决获胜 */
  hOMEBYDECISION = 401,
  /** 客队通过击倒获胜 */
  aWAYBYKO = 402,
  /** 客队通过判决获胜 */
  aWAYBYDECISION = 403,
  /** 主队通过降服获胜 */
  hOMEBYSUBMISSION = 404,
  /** 客队通过降服获胜 */
  aWAYBYSUBMISSION = 405,
  /** 红球 */
  red_406 = 406,
  /** 黄球 */
  yellow = 407,
  /** 绿球 */
  green_408 = 408,
  /** 棕球 */
  brown = 409,
  /** 蓝球 */
  blue = 410,
  /** 粉球 */
  pink = 411,
  /** 黑球 */
  black = 412,
  /** 犯规 */
  foul = 413,
  /** 达阵 */
  touchdown = 414,
  /** 射门 */
  fieldGoal = 415,
  /** 安全分 */
  safety = 416,
  /** 0-2 */
  score_0_2_420 = 420,
  /** 0-3 */
  score_0_3_421 = 421,
  /** 0-4 */
  score_0_4_422 = 422,
  /** 0-5 */
  score_0_5_423 = 423,
  /** 0-6 */
  score_0_6_424 = 424,
  /** 1-1 */
  score_1_1_425 = 425,
  /** 1-2 */
  score_1_2_426 = 426,
  /** 1-3 */
  score_1_3_427 = 427,
  /** 1-4 */
  score_1_4_428 = 428,
  /** 1-5 */
  score_1_5_429 = 429,
  /** 1-6 */
  score_1_6_430 = 430,
  /** 2-2 */
  score_2_2_431 = 431,
  /** 2-4 */
  score_2_4_432 = 432,
  /** 2-5 */
  score_2_5_433 = 433,
  /** 2-6 */
  score_2_6_434 = 434,
  /** 3-3 */
  score_3_3_435 = 435,
  /** 3-4 */
  score_3_4_436 = 436,
  /** 3-5 */
  score_3_5_437 = 437,
  /** 3-6 */
  score_3_6_438 = 438,
  /** 4-4 */
  score_4_4_439 = 439,
  /** 4-5 */
  score_4_5_440 = 440,
  /** 5-5 */
  score_5_5_441 = 441,
  /** 5-6 */
  score_5_6_442 = 442,
  /** 6-6 */
  score_6_6_443 = 443,
  /** 0 */
  n0_448 = 448,
  /** 1 */
  n1_449 = 449,
  /** 0-3 */
  score_0_3_450 = 450,
  /** 4 */
  n4_451 = 451,
  /** 5 */
  n5_452 = 452,
  /** 6 */
  n6_453 = 453,
  /** 7 */
  n7_454 = 454,
  /** 8 */
  n8_455 = 455,
  /** 9 */
  n9_456 = 456,
  /** 10 */
  n10_457 = 457,
  /** 11 */
  n11 = 458,
  /** 12+ */
  n12_459 = 459,
  /** 0-1 */
  score_0_1_460 = 460,
  /** 2 */
  n2_461 = 461,
  /** 3 */
  n3_462 = 462,
  /** 4+ */
  n4_463 = 463,
  /** 3+ */
  n3_464 = 464,
  /** 6+ */
  n6_465 = 465,
  /** 2 Sets */
  n2Sets = 466,
  /** 3 Sets */
  n3Sets = 467,
  /** 4 Sets */
  n4Sets = 468,
  /** 5 Sets */
  n5Sets = 469,
  /** 6 Sets */
  n6Sets = 470,
  /** 7 Sets */
  n7Sets = 471,
  /** 2 Games */
  n2Games = 472,
  /** 3 Games */
  n3Games = 473,
  /** 4 Games */
  n4Games = 474,
  /** 5 Games */
  n5Games = 475,
  /** 6 Games */
  n6Games = 476,
  /** 7 Games */
  n7Games = 477,
  /** Infernal */
  infernal = 478,
  /** Mountain */
  mountain = 479,
  /** Cloud */
  cloud = 480,
  /** Ocean */
  ocean = 481,
  /** Hextech */
  hextech = 482,
  /** Chemtech */
  chemtech = 483,
  /** Arcane */
  arcane = 486,
  /** Double Damage */
  doubleDamage = 487,
  /** Haste */
  haste = 488,
  /** Illusion */
  illusion = 489,
  /** Invisibility */
  invisibility = 490,
  /** Regeneration */
  regeneration = 491,
  /** {H} Win By 2-4 Rounds | Home Win By 2-4 Rounds */
  homeWinBy24Rounds = 493,
  /** {H} Win By 5-7 Rounds | Home Win By 5-7 Rounds */
  homeWinBy57Rounds = 494,
  /** {H} Win By 8-10 Rounds | Home Win By 8-10 Rounds */
  homeWinBy810Rounds = 495,
  /** {H} Win By 11-13 Rounds | Home Win By 11-13 Rounds */
  homeWinBy1113Rounds = 496,
  /** {A} Win By 2-4 Rounds | Away Win By 2-4 Rounds */
  awayWinBy24Rounds = 497,
  /** {A} Win By 5-7 Rounds | Away Win By 5-7 Rounds */
  awayWinBy57Rounds = 498,
  /** {A} Win By 8-10 Rounds | Away Win By 8-10 Rounds */
  awayWinBy810Rounds = 499,
  /** {A} Win By 11-13 Rounds | Away Win By 11-13 Rounds */
  awayWinBy1113Rounds = 500,
  /** 1,{T1} */
  n1T1 = 501,
  /** 2,{T2} */
  n2T2 = 502,
  /** 3,{T3} */
  n3T3 = 503,
  /** 4,{T4} */
  n4T4 = 504,
  /** 5,{T5} */
  n5T5 = 505,
  /** 6,{T6} */
  n6T6 = 506,
  /** 1,2 */
  n12_521 = 521,
  /** 1,3 */
  n13_522 = 522,
  /** 1,4 */
  n14_523 = 523,
  /** 1,5 */
  n15_524 = 524,
  /** 1,6 */
  n16_525 = 525,
  /** 2,1 */
  n21 = 526,
  /** 2,3 */
  n23_527 = 527,
  /** 2,4 */
  n24_528 = 528,
  /** 2,5 */
  n25_529 = 529,
  /** 2,6 */
  n26_530 = 530,
  /** 3,1 */
  n31 = 531,
  /** 3,2 */
  n32 = 532,
  /** 3,4 */
  n34_533 = 533,
  /** 3,5 */
  n35_534 = 534,
  /** 3,6 */
  n36_535 = 535,
  /** 4,1 */
  n41 = 536,
  /** 4,2 */
  n42 = 537,
  /** 4,3 */
  n43 = 538,
  /** 4,5 */
  n45_539 = 539,
  /** 4,6 */
  n46_540 = 540,
  /** 5,1 */
  n51 = 541,
  /** 5,2 */
  n52 = 542,
  /** 5,3 */
  n53 = 543,
  /** 5,4 */
  n54 = 544,
  /** 5,6 */
  n56_545 = 545,
  /** 6,1 */
  n61 = 546,
  /** 6,2 */
  n62 = 547,
  /** 6,3 */
  n63 = 548,
  /** 6,4 */
  n64 = 549,
  /** 6,5 */
  n65 = 550,
  /** 1,2 */
  n12_551 = 551,
  /** 1,3 */
  n13_552 = 552,
  /** 1,4 */
  n14_553 = 553,
  /** 1,5 */
  n15_554 = 554,
  /** 1,6 */
  n16_555 = 555,
  /** 2,3 */
  n23_556 = 556,
  /** 2,4 */
  n24_557 = 557,
  /** 2,5 */
  n25_558 = 558,
  /** 2,6 */
  n26_559 = 559,
  /** 3,4 */
  n34_560 = 560,
  /** 3,5 */
  n35_561 = 561,
  /** 3,6 */
  n36_562 = 562,
  /** 4,5 */
  n45_563 = 563,
  /** 4,6 */
  n46_564 = 564,
  /** 5,6 */
  n56_565 = 565,
  /** 0-0 / 0-0 */
  score_0_0_600 = 600,
  /** 0-0 / 0-1 */
  score_0_0_601 = 601,
  /** 0-0 / 0-2 */
  score_0_0_602 = 602,
  /** 0-0 / 0-3 */
  score_0_0_603 = 603,
  /** 0-0 / 1-0 */
  score_0_0_604 = 604,
  /** 0-0 / 1-1 */
  score_0_0_605 = 605,
  /** 0-0 / 1-2 */
  score_0_0_606 = 606,
  /** 0-0 / 2-0 */
  score_0_0_607 = 607,
  /** 0-0 / 2-1 */
  score_0_0_608 = 608,
  /** 0-0 / 3-0 */
  score_0_0_609 = 609,
  /** 0-0 / 4+ */
  score_0_0_610 = 610,
  /** 0-1 / 0-1 */
  score_0_1_611 = 611,
  /** 0-1 / 0-2 */
  score_0_1_612 = 612,
  /** 0-1 / 0-3 */
  score_0_1_613 = 613,
  /** 0-1 / 1-1 */
  score_0_1_614 = 614,
  /** 0-1 / 1-2 */
  score_0_1_615 = 615,
  /** 0-1 / 2-1 */
  score_0_1_616 = 616,
  /** 0-1 / 4+ */
  score_0_1_617 = 617,
  /** 0-2 / 0-2 */
  score_0_2_618 = 618,
  /** 0-2 / 0-3 */
  score_0_2_619 = 619,
  /** 0-2 / 1-2 */
  score_0_2_620 = 620,
  /** 0-2 / 4+ */
  score_0_2_621 = 621,
  /** 0-3 / 0-3 */
  score_0_3_622 = 622,
  /** 0-3 / 4+ */
  score_0_3_623 = 623,
  /** 1-0 / 1-0 */
  score_1_0_624 = 624,
  /** 1-0 / 1-1 */
  score_1_0_625 = 625,
  /** 1-0 / 1-2 */
  score_1_0_626 = 626,
  /** 1-0 / 2-0 */
  score_1_0_627 = 627,
  /** 1-0 / 2-1 */
  score_1_0_628 = 628,
  /** 1-0 / 3-0 */
  score_1_0_629 = 629,
  /** 1-0 / 4+ */
  score_1_0_630 = 630,
  /** 1-1 / 1-1 */
  score_1_1_631 = 631,
  /** 1-1 / 1-2 */
  score_1_1_632 = 632,
  /** 1-1 / 2-1 */
  score_1_1_633 = 633,
  /** 1-1 / 4+ */
  score_1_1_634 = 634,
  /** 1-2 / 1-2 */
  score_1_2_635 = 635,
  /** 1-2 / 4+ */
  score_1_2_636 = 636,
  /** 2-0 / 2-0 */
  score_2_0_637 = 637,
  /** 2-0 / 2-1 */
  score_2_0_638 = 638,
  /** 2-0 / 3-0 */
  score_2_0_639 = 639,
  /** 2-0 / 4+ */
  score_2_0_640 = 640,
  /** 2-1 / 2-1 */
  score_2_1_641 = 641,
  /** 2-1 / 4+ */
  score_2_1_642 = 642,
  /** 3-0 / 3-0 */
  score_3_0_643 = 643,
  /** 3-0 / 4+ */
  score_3_0_644 = 644,
  /** 4+ / 4+ */
  n44 = 645,
  /** 0 */
  n0_650 = 650,
  /** 1 */
  n1_651 = 651,
  /** 2 */
  n2_652 = 652,
  /** 3 */
  n3_653 = 653,
  /** 4 */
  n4_654 = 654,
  /** 5 */
  n5_655 = 655,
  /** 6 */
  n6_656 = 656,
  /** 7 */
  n7_657 = 657,
  /** 8 */
  n8_658 = 658,
  /** 9 */
  n9_659 = 659,
  /** 单/单/单/单 */
  oddOddOddOdd = 660,
  /** 单/单/单/双 */
  oddOddOddEven = 661,
  /** 单/单/双/单 */
  oddOddEvenOdd = 662,
  /** 单/双/单/单 */
  oddEvenOddOdd = 663,
  /** 双/单/单/单 */
  evenOddOddOdd = 664,
  /** 双/双/双/双 */
  evenEvenEvenEven = 665,
  /** 双/双/双/单 */
  evenEvenEvenOdd = 666,
  /** 双/双/单/双 */
  evenEvenOddEven = 667,
  /** 双/单/双//双 */
  evenOddEvenEven = 668,
  /** 单/双/双/双 */
  oddEvenEvenEven = 669,
  /** 单/单/双/双 */
  oddOddEvenEven = 670,
  /** 单/双/单/双 */
  oddEvenOddEven = 671,
  /** 双/单/双/单 */
  evenOddEvenOdd = 672,
  /** 双/双/单/单 */
  evenEvenOddOdd = 673,
  /** 双/单/单/双 */
  evenOddOddEven = 674,
  /** 单/双/双/单 */
  oddEvenEvenOdd = 675,
  /** 接球出局 */
  caught = 676,
  /** 投球出局 */
  bowled = 677,
  /** 触身出局 */
  lBW = 678,
  /** 被杀出局 */
  runOut = 679,
  /** 倒柱出局 */
  stumped = 680,
  /** 其他 */
  others_681 = 681,
  /** 无人出局 */
  notCaught = 682,
  /** 主 {L1} & 大 {L2} */
  homeL1OverL2 = 683,
  /** 主 {L1} & 小 {L2} */
  homeL1UnderL2 = 684,
  /** 客 {L1} & 大 {L2} */
  awayL1OverL2 = 685,
  /** 客 {L1} & 小 {L2} */
  awayL1UnderL2 = 686,
  /** 红色 */
  red_687 = 687,
  /** 绿色 */
  green_688 = 688,
  /** 0-89 */
  score_0_89 = 689,
  /** 90-100 */
  score_90_100 = 690,
  /** 101+ */
  n101 = 691,
  /** 第一局 */
  n1stInning = 692,
  /** 第二局 */
  n2ndInning = 693,
  /** 第三局 */
  n3rdInning = 694,
  /** 第四局 */
  n4thInning = 695,
  /** 第五局 */
  n5thInning = 696,
  /** 第六局 */
  n6thInning = 697,
  /** 第七局 */
  n7thInning = 698,
  /** 第八局 */
  n8thInning = 699,
  /** 第九局 */
  n9thInning = 700,
  /** Odd&Over */
  oddOver = 701,
  /** Odd&Under */
  oddUnder = 702,
  /** Even&Over */
  evenOver = 703,
  /** Even&Under */
  evenUnder = 704,
  /** {H}&{H}&Over|Home&Home&Over */
  homeHomeOver = 705,
  /** {H}&{H}&Under|Home&Home&Under */
  homeHomeUnder = 706,
  /** {H}&Draw&Over|Home&Draw&Over */
  homeDrawOver = 707,
  /** {H}&Draw&Under|Home&Draw&Under */
  homeDrawUnder = 708,
  /** {H}&{A}&Over|Home&Away&Over */
  homeAwayOver = 709,
  /** {H}&{A}&Under|Home&Away&Under */
  homeAwayUnder = 710,
  /** Draw&{H}&Over|Draw&Home&Over */
  drawHomeOver = 711,
  /** Draw&{H}&Under|Draw&Home&Under */
  drawHomeUnder = 712,
  /** Draw&Draw&Over */
  drawDrawOver = 713,
  /** Draw&Draw&Under */
  drawDrawUnder = 714,
  /** Draw&[A}&Over|Draw&Away&Over */
  drawAwayOver = 715,
  /** Draw&{A}&Under|Draw&Away&Under */
  drawAwayUnder = 716,
  /** {A}&{H}&Over|Away&Home&Over */
  awayHomeOver = 717,
  /** {A}&{H}&Under|Away&Home&Under */
  awayHomeUnder = 718,
  /** {A}&Draw&Over|Away&Draw&Over */
  awayDrawOver = 719,
  /** {A}&Draw&Under|Away&Draw&Under */
  awayDrawUnder = 720,
  /** {A}&{A}&Over|Away&Away&Over */
  awayAwayOver = 721,
  /** {A}&{A}&Under|Away&Away&Under */
  awayAwayUnder = 722,
  /** 0-0 */
  score_0_0_800 = 800,
  /** 0-1 */
  score_0_1_801 = 801,
  /** 0-2 */
  score_0_2_802 = 802,
  /** 0-3 */
  score_0_3_803 = 803,
  /** 0-4 */
  score_0_4_804 = 804,
  /** 0-5 */
  score_0_5_805 = 805,
  /** 0-6 */
  score_0_6_806 = 806,
  /** 0-7 */
  score_0_7_807 = 807,
  /** 0-8 */
  score_0_8_808 = 808,
  /** 0-9 */
  score_0_9_809 = 809,
  /** 1-0 */
  score_1_0_810 = 810,
  /** 1-1 */
  score_1_1_811 = 811,
  /** 1-2 */
  score_1_2_812 = 812,
  /** 1-3 */
  score_1_3_813 = 813,
  /** 1-4 */
  score_1_4_814 = 814,
  /** 1-5 */
  score_1_5_815 = 815,
  /** 1-6 */
  score_1_6_816 = 816,
  /** 1-7 */
  score_1_7_817 = 817,
  /** 1-8 */
  score_1_8_818 = 818,
  /** 1-9 */
  score_1_9_819 = 819,
  /** 2-0 */
  score_2_0_820 = 820,
  /** 2-1 */
  score_2_1_821 = 821,
  /** 2-2 */
  score_2_2_822 = 822,
  /** 2-3 */
  score_2_3_823 = 823,
  /** 2-4 */
  score_2_4_824 = 824,
  /** 2-5 */
  score_2_5_825 = 825,
  /** 2-6 */
  score_2_6_826 = 826,
  /** 2-7 */
  score_2_7_827 = 827,
  /** 2-8 */
  score_2_8_828 = 828,
  /** 2-9 */
  score_2_9_829 = 829,
  /** 3-0 */
  score_3_0_830 = 830,
  /** 3-1 */
  score_3_1_831 = 831,
  /** 3-2 */
  score_3_2_832 = 832,
  /** 3-3 */
  score_3_3_833 = 833,
  /** 3-4 */
  score_3_4_834 = 834,
  /** 3-5 */
  score_3_5_835 = 835,
  /** 3-6 */
  score_3_6_836 = 836,
  /** 3-7 */
  score_3_7_837 = 837,
  /** 3-8 */
  score_3_8_838 = 838,
  /** 3-9 */
  score_3_9_839 = 839,
  /** 4-0 */
  score_4_0_840 = 840,
  /** 4-1 */
  score_4_1_841 = 841,
  /** 4-2 */
  score_4_2_842 = 842,
  /** 4-3 */
  score_4_3_843 = 843,
  /** 4-4 */
  score_4_4_844 = 844,
  /** 4-5 */
  score_4_5_845 = 845,
  /** 4-6 */
  score_4_6_846 = 846,
  /** 4-7 */
  score_4_7_847 = 847,
  /** 4-8 */
  score_4_8_848 = 848,
  /** 4-9 */
  score_4_9_849 = 849,
  /** 5-0 */
  score_5_0_850 = 850,
  /** 5-1 */
  score_5_1_851 = 851,
  /** 5-2 */
  score_5_2_852 = 852,
  /** 5-3 */
  score_5_3_853 = 853,
  /** 5-4 */
  score_5_4_854 = 854,
  /** 5-5 */
  score_5_5_855 = 855,
  /** 5-6 */
  score_5_6_856 = 856,
  /** 5-7 */
  score_5_7_857 = 857,
  /** 5-8 */
  score_5_8_858 = 858,
  /** 5-9 */
  score_5_9_859 = 859,
  /** 6-0 */
  score_6_0_860 = 860,
  /** 6-1 */
  score_6_1_861 = 861,
  /** 6-2 */
  score_6_2_862 = 862,
  /** 6-3 */
  score_6_3_863 = 863,
  /** 6-4 */
  score_6_4_864 = 864,
  /** 6-5 */
  score_6_5_865 = 865,
  /** 6-6 */
  score_6_6_866 = 866,
  /** 6-7 */
  score_6_7_867 = 867,
  /** 6-8 */
  score_6_8_868 = 868,
  /** 6-9 */
  score_6_9_869 = 869,
  /** 7-0 */
  score_7_0_870 = 870,
  /** 7-1 */
  score_7_1_871 = 871,
  /** 7-2 */
  score_7_2_872 = 872,
  /** 7-3 */
  score_7_3_873 = 873,
  /** 7-4 */
  score_7_4_874 = 874,
  /** 7-5 */
  score_7_5_875 = 875,
  /** 7-6 */
  score_7_6_876 = 876,
  /** 7-7 */
  score_7_7_877 = 877,
  /** 7-8 */
  score_7_8_878 = 878,
  /** 7-9 */
  score_7_9_879 = 879,
  /** 8-0 */
  score_8_0_880 = 880,
  /** 8-1 */
  score_8_1_881 = 881,
  /** 8-2 */
  score_8_2_882 = 882,
  /** 8-3 */
  score_8_3_883 = 883,
  /** 8-4 */
  score_8_4_884 = 884,
  /** 8-5 */
  score_8_5_885 = 885,
  /** 8-6 */
  score_8_6_886 = 886,
  /** 8-7 */
  score_8_7_887 = 887,
  /** 8-8 */
  score_8_8_888 = 888,
  /** 8-9 */
  score_8_9_889 = 889,
  /** 9-0 */
  score_9_0_890 = 890,
  /** 9-1 */
  score_9_1_891 = 891,
  /** 9-2 */
  score_9_2_892 = 892,
  /** 9-3 */
  score_9_3_893 = 893,
  /** 9-4 */
  score_9_4_894 = 894,
  /** 9-5 */
  score_9_5_895 = 895,
  /** 9-6 */
  score_9_6_896 = 896,
  /** 9-7 */
  score_9_7_897 = 897,
  /** 9-8 */
  score_9_8_898 = 898,
  /** 9-9 */
  score_9_9_899 = 899,
  /** 13-0 */
  score_13_0 = 901,
  /** 13-1 */
  score_13_1 = 902,
  /** 13-2 */
  score_13_2 = 903,
  /** 13-3 */
  score_13_3 = 904,
  /** 13-4 */
  score_13_4 = 905,
  /** 13-5 */
  score_13_5 = 906,
  /** 13-6 */
  score_13_6 = 907,
  /** 13-7 */
  score_13_7 = 908,
  /** 13-8 */
  score_13_8 = 909,
  /** 13-9 */
  score_13_9 = 910,
  /** 13-10 */
  score_13_10 = 911,
  /** 13-11 */
  score_13_11 = 912,
  /** 12-12 */
  score_12_12 = 913,
  /** 0-13 */
  score_0_13 = 914,
  /** 1-13 */
  score_1_13 = 915,
  /** 2-13 */
  score_2_13 = 916,
  /** 3-13 */
  score_3_13 = 917,
  /** 4-13 */
  score_4_13 = 918,
  /** 5-13 */
  score_5_13 = 919,
  /** 6-13 */
  score_6_13 = 920,
  /** 7-13 */
  score_7_13 = 921,
  /** 8-13 */
  score_8_13 = 922,
  /** 9-13 */
  score_9_13 = 923,
  /** 10-13 */
  score_10_13 = 924,
  /** 11-13 */
  score_11_13 = 925,
}
